<template>
    <div v-if="show">
        <ion-row>
            <ion-col class="fs-smaller grey1-grey1-color">
                {{ $t(`placeholder.${ISSUE_TYPE.FEATURE}.expectation`) }}*
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <textarea-simple
                    v-model="descriptionTemplate.expectation"
                    :validate-option="{ name: 'expectation', label: $t('label.expectation') }"
                />
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col class="fs-smaller grey1-grey1-color">
                {{ $t(`placeholder.${ISSUE_TYPE.FEATURE}.place`) }}*
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <textarea-simple
                    v-model="descriptionTemplate.place"
                    :validate-option="{ name: 'place', label: $t('label.place') }"
                />
            </ion-col>
        </ion-row>
    </div>
</template>

<script setup lang="ts">import { computed as _computed } from 'vue';

import { IonCol, IonRow } from "@ionic/vue";
import { useForm } from "vee-validate";

import TextareaSimple from "@/components/input/TextareaSimple.vue";

import { ISSUE_TYPE } from "@/types/enum/general";
import { FeedbackFeatureProps } from "@/types/props";
import { FeedbackFeatureEmits } from "@/types/emits";

const props = defineProps<FeedbackFeatureProps>()
const emit = defineEmits<FeedbackFeatureEmits>()

const descriptionTemplate = _computed({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
    }
})

const { meta, resetForm, validate } = useForm({
    validationSchema: {
        expectation: 'required',
        place: 'required'
    }
})

defineExpose({
    meta,
    resetForm,
    validate
})
</script>
